import { render, staticRenderFns } from "./UserRolePictureView.vue?vue&type=template&id=0c88d1f1&scoped=true"
import script from "./UserRolePictureView.vue?vue&type=script&lang=js"
export * from "./UserRolePictureView.vue?vue&type=script&lang=js"
import style0 from "./UserRolePictureView.vue?vue&type=style&index=0&id=0c88d1f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c88d1f1",
  null
  
)

export default component.exports